import React from 'react';
import styles from './TextArea.module.scss';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

export function TextArea({
  id,
  label,
  rows,
  column,
  placeholder,
  defaultValue,
  readOnly,
  value,
  onChange,
  error = false
}) {
  return (
    <div className={styles.TextAreaComponent}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <textarea
        onChange={onChange}
        readOnly={readOnly}
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        className={styles.TextAreaComponent__Styles}
        id={id}
        name={label}
        rows={rows}
        cols={column}
      />
      {error && <ValidationErrorLabel message={error} />}
    </div>
  );
}
